import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=b1408d6e&lang=pug"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js"
import style0 from "./DeleteAccountModal.vue?vue&type=style&index=0&id=b1408d6e&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports